import { render, staticRenderFns } from "./lightMarquee.vue?vue&type=template&id=845abb16&scoped=true&"
import script from "./lightMarquee.vue?vue&type=script&lang=js&"
export * from "./lightMarquee.vue?vue&type=script&lang=js&"
import style0 from "./lightMarquee.vue?vue&type=style&index=0&id=845abb16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845abb16",
  null
  
)

export default component.exports